import axios from 'axios';

import { callGlobalShowAlert } from '@/shared/utils/globalAlert';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: false,
			refetchOnWindowFocus: false,
			refetchOnMount: false,
			refetchOnReconnect: false,
			staleTime: 1000 * 60 * 5,
			gcTime: 1000 * 60 * 10,
		},
		mutations: {
			retry: false,
		},
	},
	queryCache: new QueryCache({
		onError: error => {
			if (axios.isAxiosError(error)) {
				callGlobalShowAlert({
					title: 'Error',
					description:
						error.response?.data?.errorMessage ||
						error.message ||
						'An unexpected error occurred.',
				});
			} else {
				callGlobalShowAlert({
					title: 'Error',
					description: 'An unexpected error occurred.',
				});
			}
		},
	}),
	mutationCache: new MutationCache({
		onError: error => {
			if (axios.isAxiosError(error)) {
				callGlobalShowAlert({
					title: 'Error',
					description:
						error.response?.data?.errorMessage ||
						error.message ||
						'An unexpected error occurred.',
				});
			} else {
				callGlobalShowAlert({
					title: 'Error',
					description: 'An unexpected error occurred.',
				});
			}
		},
	}),
});
